function prepopulatePhoneNumber() {
  //Load the default phone number in place, then initiate an AJAX call in case the default phone number isn't the
  // right choice for the user. The default phone number might subsequently be changed by If the user is in a french speaking location, i.e. montreal, the default phone
  // number will have to be replaced. Note that the
  // console.log('checking defaultGlobalPhoneNumber')
  if (defaultGlobalPhoneNumber) {
    //do not replace phone number for .phone-number-pre-populated, set for landing pages. landing pages have their
    // phone number set in the "phone_number_header" ACF Field titled "Phone Number in Header"
    jQuery('#get_phone')
      .not('.phone-number-pre-populated')
      .attr('href', 'tel:' + defaultGlobalPhoneNumber);
    jQuery('#get_phone')
      .not('.phone-number-pre-populated')
      .html('<span class="camainnumber">' + defaultGlobalPhoneNumber + '</span>');

    jQuery('#phone_ftr').html('<span class="camainnumber">' + defaultGlobalPhoneNumber + '</span>');
    jQuery('#phone_ftr').attr('href', 'tel:' + defaultGlobalPhoneNumber);

    jQuery('#dynamic_phone_number').html('<span class="camainnumber">' + defaultGlobalPhoneNumber + '</span>');
    jQuery('#dynamic_phone_number').attr('href', 'tel:' + defaultGlobalPhoneNumber);

    jQuery('#mob_get_phone').attr('href', 'tel:' + defaultGlobalPhoneNumber);

    jQuery('#side_link_ph_no').attr('href', 'tel:' + defaultGlobalPhoneNumber);

    jQuery('#side_phone_no').html('<span class="camainnumber">' + defaultGlobalPhoneNumber + '</span>');
  }
}

function fetchEntireContent() {
  $('input.http_referer').val(document.referrer);

  if (jQuery('#ajax_our_designers').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_designers_ajax',
        wpml_lang: wpml_lang,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#ajax_our_designers').html(data);
      },
    });
  }

  if (jQuery('#localised_home_slider').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_hp_slider_ajax',
        wpml_lang: wpml_lang,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        jQuery('#localised_home_slider').html(data);
        var options = {
          types: ['geocode'], // @see https://developers.google.com/maps/documentation/javascript/supported_types#table3
          componentRestrictions: { country: 'ca' },
        };
        if (document.getElementById('autocompletebanner')) {
          autocompletebanner = new google.maps.places.Autocomplete(
            /** @type {!HTMLInputElement} */ (document.getElementById('autocompletebanner')),
            options
          );
          autocompletebanner.addListener('place_changed', function () {
            fillInAddressFinder('banner');
          });
        }
      },
    });
  }

  if (jQuery('#get_phone').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'fetch_phone_ajax',
        wpml_lang: wpml_lang,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        // console.log('fetch phone ajax returned')
        if (data != '') {
          var phone = data.split('!')[0];
          var isGlobal = data.split('!')[1];
          if (isGlobal == 'M') {
            // console.log('market phone found. setting it.')
            jQuery('#get_phone').attr('href', 'tel:' + phone);
            jQuery('#get_phone').html(phone);

            jQuery('#mob_get_phone').attr('href', 'tel:' + phone);
            jQuery('#phone_ftr').html(phone);
            jQuery('#dynamic_phone_number').html(phone);
            jQuery('#side_link_ph_no').attr('href', 'tel:' + phone);
            jQuery('#side_phone_no').html(phone);
          } else {
            // console.log('global phone found. no need to set it. ')
            //Global (!G) phone already applied before ajax. @see prepopulatePhoneNumber
          }
        }

        //Dialogtech script, decommissioned.
        // (function(){
        //     var a=document, b=a.createElement("script"); b.type="text/javascript";
        //     b.async=!0; b.src=('https:'==document.location.protocol ? 'https://' :
        //     'http://') + 'd31y97ze264gaa.cloudfront.net/assets/st/js/st.js';
        //     a=a.getElementsByTagName("script")[0]; a.parentNode.insertBefore(b,a);
        // })();
        // _st.render();

        // Setting  phone already done in @see prepopulatePhoneNumber and/or above as a result of the ajax call
        // setTimeout(function() {
        // 	if(isGlobal == "M") {
        // 		var currP = jQuery('#get_phone').html();
        // 		jQuery('#get_phone').attr("href", "tel:" + currP);
        //     	jQuery('#mob_get_phone').attr("href", "tel:" + currP);
        //     	jQuery('#side_link_ph_no').attr("href", "tel:" + currP);
        //     	jQuery('#phone_ftr').attr("href", "tel:" + currP);
        // 	}
        // 	else {
        //     	var currP = jQuery('#get_phone span').html();
        //     	jQuery('#get_phone').attr("href", "tel:" + currP);
        //     	jQuery('#mob_get_phone').attr("href", "tel:" + currP);
        //     	jQuery('#side_link_ph_no').attr("href", "tel:" + currP);
        //     	jQuery('#phone_ftr').attr("href", "tel:" + currP);
        //     }
        // }, 1000);
      },
    });
  }

  if (jQuery('#room_testimonial').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_latest_testimonial',
        wpml_lang: wpml_lang,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        jQuery('#room_testimonial').html(data);
      },
    });
  }

  if (jQuery('#testimonial-list-page').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_testimonial_page',
        currPage: currPage,
        pagedCustom: pagedCustom,
        locationTax: locationTax,
        wpml_lang: wpml_lang,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        jQuery('.testimonial-content').html(data);
      },
    });
  }

  /*Ajax clients story*/
  if (jQuery('#clients-stories-ajax').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'fetch_client_stories',
        wpml_lang: wpml_lang,
        pageID: pageID,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#clients-stories-ajax').html(data);
      },
    });
  }

  //get to the trade by ajax
  if (jQuery('#trade-in-market_ajax').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_trade_in_market_ajax',
        wpml_lang: wpml_lang,
        pageID: pageID,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#trade-in-market_ajax').html(data);
      },
    });
  }

  //get Our Work by ajax
  if (jQuery('#our_work_ajax').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_our_work_ajax',
        wpml_lang: wpml_lang,
        pageID: pageID,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#our_work_ajax').html(data);
      },
    });
  }

  //get Market promo by ajax
  if (jQuery('#promo-market-ajax').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_market_promo_ajax',
        wpml_lang: wpml_lang,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#promo-market-ajax').html(data);
        //call a window resize, that accounts for mobile views adaptations
        window.dispatchEvent(new Event('resize'));
      },
    });
  }

  //get the trade by ajax
  if (jQuery('#to-the-trade-ajax').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_to_the_trade_ajax',
        wpml_lang: wpml_lang,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#to-the-trade-ajax').html(data);
        //call a window resize, that accounts for mobile views adaptations
        window.dispatchEvent(new Event('resize'));
      },
    });
  }

  //get meet our deigner by ajax
  if (jQuery('#meet-our-designer-ajax').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_meet_our_designer_ajax',
        wpml_lang: wpml_lang,
        pageID: pageID,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#meet-our-designer-ajax').html(data).show();
        //call a window resize, that accounts for mobile views adaptations
        window.dispatchEvent(new Event('resize'));
      },
    });
  }

  //get locally own custom crafted by ajax
  if (jQuery('#local-custom-crafted').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_custom_crafted_ajax',
        wpml_lang: wpml_lang,
        pageID: pageID,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#local-custom-crafted').html(data);
        //call a window resize, that accounts for mobile views adaptations
        window.dispatchEvent(new Event('resize'));
      },
    });
  }

  //get expert advice by ajax according to market
  if (jQuery('#expert-advice-ajax').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_expert_advice_ajax',
        wpml_lang: wpml_lang,
        pageID: pageID,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#expert-advice-ajax').html(data);
        //call a window resize, that accounts for mobile views adaptations
        window.dispatchEvent(new Event('resize'));
      },
    });
  }

  //get see more link of TV Client Stroy by ajax
  if (jQuery('#tvcat').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_see_more_tv_link',
        wpml_lang: wpml_lang,
        pageID: pageID,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#tvcat').html(data);
        //call a window resize, that accounts for mobile views adaptations
        window.dispatchEvent(new Event('resize'));
      },
    });
  }

  //get see more link of Media Client Stroy by ajax
  if (jQuery('#mediacat').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_see_more_media_link',
        wpml_lang: wpml_lang,
        pageID: pageID,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#mediacat').html(data);
        //call a window resize, that accounts for mobile views adaptations
        window.dispatchEvent(new Event('resize'));
      },
    });
  }

  //get see more link of Local Client Stroy by ajax
  if (jQuery('#localcat').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'get_see_more_local_link',
        wpml_lang: wpml_lang,
        pageID: pageID,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        //alert(data);
        jQuery('#localcat').html(data);
        //call a window resize, that accounts for mobile views adaptations
        window.dispatchEvent(new Event('resize'));
      },
    });
  }

  //Added by Pawan for making Our Designers page AJAX based for localisation
  if (jQuery('#page_our_designers').length > 0) {
    jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'page_designers_ajax',
        wpml_lang: wpml_lang,
        marketID: cookieMktID,
      },
      success: function (data, textStatus, XMLHttpRequest) {
        jQuery('#page_our_designers').html(data);

        if (jQuery('.videoPopup').length > 0) {
          jQuery('body').on('click', '.videoPopup', function (e) {
            e.preventDefault();
            jQuery.fancybox({
              padding: 15,
              autoScale: false,
              transitionIn: 'none',
              transitionOut: 'none',
              href: this.href.replace(new RegExp('watch\\?v=', 'i'), 'v/').replace('/v/', '/embed/'),
              type: 'iframe',
            });
            return false;
          });
        }
      },
    });
  }

  //get houzz image by ajax
  if (jQuery('#houzz-image-ajax').length > 0) {
    if (jQuery('#houzz-image-ajax img.desktop-houzz').length > 0) {
      jQuery('#houzz-image-ajax').addClass('houzz-icon');
    } else if (document.getElementById('autocompletefooter')) {
      jQuery('#houzz-image-ajax').addClass('foot-search');

      jQuery('.lf-finder-footer').unbind('click');

      jQuery('.lf-finder-footer').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var thisel = this;
        this.disabled = true;
        locationFinder(thisel, 'autocompletefooter');
        this.disabled = false;
        return false;
      });
    }
  }
}
